import {SCDOptionsType} from 'common/widgets/property-filter-menu/models/types';

import {isBehaviorShowClause} from '../models/utils';
import {InsightsBookmarkParams} from './types';

export function hasSCDOptionsType(type: SCDOptionsType, bookmark: InsightsBookmarkParams) {
  return (
    bookmark.sections.show.some(
      (show) =>
        isBehaviorShowClause(show) && show.behavior?.filters?.some((filter) => filter.scdOptions?.type === type),
    ) ||
    bookmark.sections.filter?.some((filter) => filter.scdOptions?.type === type) ||
    bookmark.sections.group?.some((group) => group.scdOptions?.type === type)
  );
}
